import { getExportFailureMessage } from "../../../constants/RendererFailureCodes"

export const SocialPlatformNames = {
    TWITTER: 'X',
    FACEBOOK: 'Facebook',
    YOUTUBE: 'YouTube'
}

export const ExportMessages = {
    initialization: {
        title: 'Preparing...',
    },
    failed: {
        title: 'Export Failed',
        description: (code, watermarkedExport) => getExportFailureMessage(code, watermarkedExport) 
    },
    canceled: {
        title: 'Export Canceled',
        description: 'The video export was canceled.'
    }
}